// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"06cc8934","703":"7cba69ec","845":"bbd43b2b"}[chunkId] + ".chunk.js";
};